const globalConfig = require('../../static/js/config');

/**
 * 全局配置
 */
for (let key in globalConfig) {
  window[key] = globalConfig[key];
}





// WEBPACK FOOTER //
// ./src/utils/setWindow.js